"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InActiveClearFiltersIcon = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26" },
        react_1.default.createElement("path", { d: "M3873.373-3235.75h-22.746a1.626,1.626,0,0,0-1.149,2.774l9.272,9.274v9.483h0a1.85,1.85,0,0,0,.555,1.223l3.25,2.843a1.626,1.626,0,0,0,2.7-1.223V-3223.7l9.272-9.274A1.626,1.626,0,0,0,3873.373-3235.75Zm-9.748,11.375v13l-3.25-2.844v-10.156l-9.75-9.75h22.75Z", transform: "translate(-3849 3235.75)", fill: "#008272", fillOpacity: "0.25" })));
};
exports.default = react_1.memo(InActiveClearFiltersIcon);
